<template>
  <div>
    <v-btn
      depressed
      color="primary"
      class="button-base"
      :loading="documentsLoading"
      @click="loadDocuments"
    >
      Добавить документ из профиля
    </v-btn>

    <BaseModalView v-model="dialogOpen" :divider="false" max-width="1200px">
      <template v-slot:title>Документы из профиля</template>
      <template v-slot:body>
        <DocumentTableViewer
          :documents="documents"
          :multiselectable="multiple"
          :selectable="true"
          ref="documentTableViewer"
        />
      </template>
      <template v-slot:buttons>
        <div class="form form-base">
          <v-row justify="end">
            <v-col cols="auto">
              <v-btn
                @click="dialogOpen = false"
                depressed
                class="button-base-white"
              >
                Отмена
              </v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn
                @click="addDocument"
                depressed
                color="primary"
                class="button-base"
              >
                Добавить документ
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
    </BaseModalView>
  </div>
</template>

<script>
import BaseModalView from '../../base/BaseModalView';
import DocumentTableViewer from '../../base/DocumentTableViewer';
import { getUserDocuments } from '@/api/profile';

export default {
  name: 'LoadDocumentProfile',
  components: {
    BaseModalView,
    DocumentTableViewer,
  },
  props: {
    documentType: {
      type: String,
    },
    multiple: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    dialogOpen: false,
    documents: [],
    documentsLoading: false,
  }),
  methods: {
    async loadDocuments() {
      this.documentsLoading = true;
      this.documents = await getUserDocuments(this.documentType);
      this.documentsLoading = false;
      this.dialogOpen = true;
    },

    async addDocument() {
      const getDocument = this.multiple
        ? this.$refs.documentTableViewer.getSelectedDocuments
        : this.$refs.documentTableViewer.getSelectedDocument;
      const document = await getDocument();

      this.$emit('change', document);

      this.dialogOpen = false;
    },
  },
};
</script>
